import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { useNavigate } from "react-router-dom";
import { getAllPayments } from "../../Services/api";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";

const Payment = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      name: "name",
      label: "Name",
      // options: {
      //   customBodyRender: (value, tableMeta) => {
      //     const name = data[tableMeta.rowIndex].name;
      //     return name;
      //   },
      // },
    },
    {
      name: "email",
      label: "Email",
      // options: {
      //   customBodyRender: (value, tableMeta) => {
      //     const phone = data[tableMeta.rowIndex].mobile;
      //     return phone;
      //   },
      // },
    },
    { name: "amount", label: "Amount" },
    {
      name: "subscriptionType",
      label: "Subscription Type",
    },
  ];

  const options = {
    filterType: "checkbox",
    print: "false",
    download: "false",
    viewColumns: "false",
    filter: false,
    selectableRows: false,
    // customToolbar: addButton,
  };

  const getPayment = async () => {
    setLoading(true);
    try {
      const result = await getAllPayments();
      setData(result);

      console.log(result);
    } catch (error) {
      setLoading(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPayment();
  }, []);

  return (
    <>
      {loading ? (
        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <ToastContainer autoClose={1000} />
          <MUIDataTable
            title={"Payment List"}
            data={data}
            columns={columns}
            options={options}
          />
        </>
      )}
    </>
  );
};

export default Payment;
